import React, { ReactNode, useEffect } from 'react';
import './XS.css';

type Input = {
    children: ReactNode;
};

export function XS(input: Input) {
    const { children } = input;

    useEffect(() => {
        document.documentElement.classList.add('XS');

        return () => {
            document.documentElement.classList.remove('XS');
        };
    }, []);

    return <>{children}</>;
}
